'use client';

import { useRouter } from 'next/navigation';
import { useState } from 'react';
import LegacySuccessIconWithShadow from 'src/app/_components/icons/legacy/LegacySuccessIconWithShadow';
import SecureNextImage from 'src/components/_common/SecureNextImage';
import { useAppDispatch } from 'src/store/client/config';
import { footballActions } from 'src/store/client/slices/football/footballSlice';
import { modalActions } from 'src/store/client/slices/modalSlice';

import LoadingSpinner from '@/app/(football)/[team]/_components/common/LoadingSpinner';
import ModalButton from '@/app/(football)/[team]/_components/common/ModalButton';
interface CardUnlockSuccessModalProps {
  cardName: string;
  image: string;
  metadataIdx: number;
  packIdx: number;
  point: number;
  totalPoint: number;
  teamSlug: string;
}

export default function CardUnlockSuccessModal({
  cardName,
  image,
  metadataIdx,
  packIdx,
  point,
  totalPoint,
  teamSlug,
}: CardUnlockSuccessModalProps) {
  const dispatch = useAppDispatch();
  const router = useRouter();

  const [isImageLoaded, setIsImageLoaded] = useState(false);

  const handleCloseModal = () => {
    dispatch(modalActions.closeModal());
  };

  const handleRouteToMyCollection = () => {
    dispatch(
      footballActions.setFlippableCardIdx({
        metaDataIdx: metadataIdx,
        packIdx,
      }),
    );

    router.push(`/${teamSlug}/my-collection`);
    handleCloseModal();
  };

  return (
    <div className="flex max-h-[480px] w-[320px] flex-col items-center rounded-lg bg-g-00 px-5 py-6">
      {/* 아이콘 */}
      <div className="mb-5 flex items-center justify-center">
        <LegacySuccessIconWithShadow
          size={56}
          foreground="var(--color-modal-icon)"
          background="#E8E8E8"
          gradient={{ from: '#E9E9E9', to: '#DADADA' }}
        />
      </div>

      {/* 바디 */}
      <div className="flex w-full flex-col items-center gap-2">
        {/* 타이틀 */}
        <p className="typo-body-1 text-center text-g-90">
          {!isImageLoaded && '카드 정보 로딩 중...'}
          {isImageLoaded && `${cardName} 카드 추가 획득!`}
        </p>

        <div className="flex w-full flex-col items-center gap-2">
          {!isImageLoaded && (
            <div className="flex items-center justify-center py-2">
              <LoadingSpinner size={28} />
            </div>
          )}

          {/* 포인트 */}
          <p className="typo-body-5 text-center text-g-60">(+{point} Point)</p>

          {/* 카드 이미지 */}
          <div className="my-2">
            <SecureNextImage
              src={image}
              alt={`${cardName} 카드 이미지`}
              width={104}
              height={160}
              loading="eager"
              onLoad={() => setIsImageLoaded(true)}
            />
          </div>

          {/* 보유 포인트 */}
          <div className="flex w-full items-center justify-between rounded border border-g-30 px-4 py-3">
            <span className="typo-body-5 text-[#7e7e7e]">보유 포인트</span>
            <span className="typo-body-4 text-[#121212]">{totalPoint}P</span>
          </div>
        </div>
      </div>

      {/* 버튼 영역 */}
      <div className="mt-6 flex w-full items-center gap-2">
        <ModalButton variant="secondary" onClick={handleRouteToMyCollection} disabled={!isImageLoaded}>
          획득 카드 보기
        </ModalButton>
        <ModalButton variant="primary" onClick={handleCloseModal} disabled={!isImageLoaded}>
          확인
        </ModalButton>
      </div>
    </div>
  );
}
